import { PositionContextType } from "../displayComponents/displayElements/DisplayElements";
import { ElementProps } from "../functionalComponents/RenderPage";

function createTestId({ isPreviewer, type, atomId, position }: { isPreviewer: boolean, type: ElementProps["type"], atomId: number, position: PositionContextType }) {
    return `${isPreviewer ? "previewer:" : ""}${type}${atomId}-${position}`
}


export default createTestId